import { collection, getDocs, query } from "firebase/firestore";
import { db } from "../firebase";
import { setQuery, queryItem } from "../firestore/QueryBase";
import { Company } from "../model/Companies";

export const getTenantId = async (tenantDisplayId: string): Promise<{success: boolean, data: string | any}> => {
  try {
    const item: queryItem[] = [
      {
        name: "displayId",
        value: tenantDisplayId,
        operator: "==",
      },
      {
        name: "deleteFlg",
        value: false,
        operator: "==",
      },
    ];
    const whereParam = setQuery(item);
    const tenantRef = await getDocs(query(collection(db, "companies"), whereParam[0], whereParam[1]));
    if(tenantRef.docs.length <= 0){
      throw new Error();
    }
    const company = tenantRef.docs[0].data() as Company;
    return {success: true, data: company.id};
  } catch (err: any) {
    console.error(err);
    return {success: false, data: err};
  }
};
